import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { getServiceList } from '../../../utils/ServiceList'
import { ServiceType } from '@modul-connect/shared/utils/services'
import TrackerMaintenance from './subPages/maintenance/maintenance'
import AssetTrackerStatusPage from './subPages/trackers/assetTrackerStatusPage'
import OrganisationToolConfiguration from './subPages/settings/organisationToolConfiguration'

export const subPageOptions = {
  maintenance: 'maintenance',
  trackers: 'trackers',
}

const AssetsReportPage = ({ subtrees, selected_organisations }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const pathSegments = location.pathname.split('/').filter(Boolean)
  const lastSegment = pathSegments[pathSegments.length - 1]

  const validOrganisationIds = subtrees?.subtrees 
    ? subtrees.subtrees.map(org => org.uuid) 
    : []

  const isMaintenance = lastSegment === subPageOptions.maintenance
  const isTrackers = lastSegment === subPageOptions.trackers
  const isValidOrgId = validOrganisationIds.includes(lastSegment)

  useEffect(() => {
    if (location.pathname.includes('/reports/reports_asset-trackers')) {
      if (!isTrackers && !isMaintenance && !isValidOrgId) {
        navigate('/reports/reports_asset-trackers/' + subPageOptions.trackers, { replace: true })
      }
    }
  }, [lastSegment, isTrackers, isMaintenance, isValidOrgId, navigate])

  const disabled = !getServiceList({ subtrees }).hasServiceForSelected(selected_organisations, ServiceType.AssetTrackers)
  const hasNotMaintenanceService = !getServiceList({ subtrees }).hasService(ServiceType.MaintenanceAccess)

  if (isMaintenance) {
    return <TrackerMaintenance disabled={hasNotMaintenanceService} />
  }

  if (isValidOrgId) {
    return <OrganisationToolConfiguration disabled={disabled} organisationId={lastSegment} />
  }

  return <AssetTrackerStatusPage disabled={disabled} />
}

const mapStateToProps = (props) => props

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(AssetsReportPage)